import type {
  DocumentsPageSize,
  DocumentsSort,
  PersonDocumentsTable,
} from '~/features/home/documents/homeDocuments';

import { pilotV3 } from '~/services/serviceInstances';

type ServerResponse = {
  columns: string[];
  sort: DocumentsSort | null;
  page_size: DocumentsPageSize;
};

const mapResponse = (response: ServerResponse): PersonDocumentsTable => ({
  columns: response.columns,
  sort: response.sort,
  pageSize: response.page_size,
});

export const getHomeDocuments = async (
  _?: void,
): Promise<PersonDocumentsTable> => {
  const response: ServerResponse = await pilotV3.get(
    '/home/documents/settings/',
  );
  return mapResponse(response);
};
